import {
  PlaylistDTO,
  PlaylistDTOCompanion,
} from "../../../dto/v3/playlist/PlaylistDTO";
import { PLAYLIST_LOCAL_STORAGE_ENTITY_NAME } from "../../EntityNames";
import LocalStoragePersistence from "../../common/LocalStoragePersistence";
import EntityLocalStorageKey from "../../common/EntityLocalStorageKey";
import { DtoId } from "../../../dto/DtoId";
import { EntityDTO, EntityDTO as EntityDTOv4 } from "../../../dto/v3/EntityDTO";
import { ParseError } from "../../../dto/parsing/JsonParsing";
import { ok, Result } from "neverthrow";

/**
 * @deprecated use v4
 */
export class PlaylistLocalStoragePersistence {
  protected buildFromParsedJson(parsedJson: PlaylistDTO): PlaylistDTO {
    return PlaylistDTOCompanion.fromParsedJson(parsedJson);
  }

  public load(identifier: DtoId): Result<PlaylistDTO | undefined, ParseError> {
    return LocalStoragePersistence.read<PlaylistDTO | undefined>(
      this.localStorageKey(identifier),
    ).andThen((parsedJson) =>
      parsedJson !== undefined
        ? ok(this.buildFromParsedJson(parsedJson))
        : ok(undefined),
    );
  }

  protected localStorageKey(identifier: DtoId): EntityLocalStorageKey {
    return new EntityLocalStorageKey(
      PLAYLIST_LOCAL_STORAGE_ENTITY_NAME,
      identifier,
    );
  }

  /**
   * Be aware: Also identifiers of removed playlists are returned here!
   */
  public static loadAllIdentifiers(): ReadonlyArray<string> {
    return LocalStoragePersistence.loadAllIdentifiersForEntity(
      PLAYLIST_LOCAL_STORAGE_ENTITY_NAME,
    );
  }

  public loadAllIdentifiersWithSchemaV3(): ReadonlyArray<string> {
    return PlaylistLocalStoragePersistence.loadAllIdentifiers()
      .map((i: string) => {
        const parsedJson: EntityDTO | EntityDTOv4 | undefined =
          LocalStoragePersistence.read<EntityDTO | EntityDTOv4>(
            this.localStorageKey(i),
          )
            .orTee((e) =>
              console.error(
                "Could not read playlist. Ignoring while loading all identifiers for v3.",
                e,
              ),
            )
            .unwrapOr(undefined);
        if (parsedJson?.schemaVersion === PlaylistDTOCompanion.SCHEMA_VERISON) {
          return i;
        } else {
          return undefined;
        }
      })
      .filter((i): i is string => i !== undefined);
  }
}
